import { FC, ReactNode } from 'react';

import { CircularProgress } from '@mui/material';
import { Box } from '@mui/system';

import CircularProgressWithLabel from '@/shared/components/utilities/CircularProgressWithLabel';

import ModalNotification from './ModalNotification';

type WaveUIProgressDialogProps = {
  title: ReactNode;
  progress: number;
  open: boolean;
  onClose?: () => void;
};

const WaveUIProgressDialog: FC<WaveUIProgressDialogProps> = ({
  title,
  progress,
  open,
  onClose,
}) => {
  return (
    <ModalNotification
      fullWidth
      size='xs'
      open={open}
      onClose={onClose}
      dialogProps={{
        title,
        titleProps: {
          textAlign: 'center',
        },
        content: (
          <Box sx={{ textAlign: 'center' }}>
            {progress > 0 ? (
              <CircularProgressWithLabel value={progress} size={70} />
            ) : (
              <CircularProgress size={70} />
            )}
          </Box>
        ),
        actions: [],
      }}
    />
  );
};

export default WaveUIProgressDialog;
